import { fetchAPI, sendNotification } from '@bsd/dashboard-toolkit/utils'
import { buildURLQuery } from '../utils'

export const loadCameras = (query) => async (dispatch) => {
  dispatch({ type: 'LOAD_CAMERAS' })
  try {
    let url = '/in/globe3d/cameras'
    if (query) {
      url += '?' + buildURLQuery(query)
    }
    const cameras = await fetchAPI(url)
    dispatch({ type: 'LOAD_CAMERAS_SUCCESS', cameras })
    return cameras
  } catch (error) {
    dispatch({ type: 'LOAD_CAMERAS_FAIL', error })
  }
}

export const loadCamera = (cameraId) => async (dispatch) => {
  dispatch({ type: 'LOAD_CAMERA' })
  try {
    const camera = await fetchAPI(`/in/globe3d/cameras/${cameraId}`)
    dispatch({ type: 'LOAD_CAMERA_SUCCESS', camera })
    return camera
  } catch (error) {
    dispatch({ type: 'LOAD_CAMERA_FAIL', error })
  }
}

export const createCamera = (data) => async (dispatch) => {
  dispatch({ type: 'CREATE_CAMERA' })
  try {
    const camera = await fetchAPI(`/in/globe3d/cameras`, 'POST', data, true)
    dispatch({ type: 'CREATE_CAMERA_SUCCESS', camera })
    sendNotification({ level: 'success', message: 'Камера успешно сохранена' })
    return camera
  } catch (error) {
    dispatch({ type: 'CREATE_CAMERA_FAIL', error })
    sendNotification({ level: 'error', message: 'При сохранении произошла ошибка' })
  }
}

export const updateCamera = (cameraId, data) => async function(dispatch) {
  dispatch({ type: 'UPDATE_CAMERA' })
  try {
    const camera = await fetchAPI(`/in/globe3d/cameras/${cameraId}`, 'PUT', data, true)
    dispatch({ type: 'UPDATE_CAMERA_SUCCESS', camera })
    sendNotification({ level: 'success', message: 'Камера успешно сохранена' })
    return camera
  } catch (error) {
    dispatch({ type: 'UPDATE_CAMERA_FAIL', error })
    sendNotification({ level: 'error', message: 'При сохранении произошла ошибка' })
  }
}

export const deleteCamera = (cameraId) => async function(dispatch) {
  dispatch({ type: 'DELETE_CAMERA' })
  try {
    await fetchAPI(`/in/globe3d/cameras/${cameraId}`, 'DELETE')
    dispatch({ type: 'DELETE_CAMERA_SUCCESS', cameraId })
    sendNotification({ level: 'success', message: 'Камера успешно удалена' })
  } catch (error) {
    dispatch({ type: 'DELETE_CAMERA_FAIL', error })
    sendNotification({ level: 'error', message: 'При удалении произошла ошибка' })
  }
}
